import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { ThemeContext } from './ThemeContext';
import FinancialStatus from '././Charts/FinancialStatus';
import PurchasesAndPayments from '././Charts/PurchasesAndPayments';
import SaleAndReceipts from '././Charts/SaleAndReceipts';
import CostsAndRevenue from '././Charts/CostsAndRevenue';
import MyGrid from './Charts/MyGrid';

export class Home extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            activeTab: 'financial-status',
            time: new Date()
        }

    }
    static contextType = ThemeContext;
    componentDidMount() {
        this.httpPost("api/v1/dashboard")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }

            });
        this.intervalId = setInterval(this.tick, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    handleTabClick = (tabName) => {
        this.setState({ activeTab: tabName });
    };


    renderForm() {

        const { activeTab } = this.state;
        const { theme } = this.context;

        return <div className={`nk-content-body ${theme}`}>
            <div className="nk-block-head nk-block-head-sm ">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h3 className="nk-block-title page-title">نمای کلی</h3>
                        <div className="nk-block-des text-soft ">
                            <p>{this.state.data.global.user.fname} {this.state.data.global.user.lname} عزیز خوش آمدید</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`card card-bordered card-preview ${theme}`}>
                <ul className="nav nav-tabs mt-n8 ms-3 me-3 mb-3">
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'financial-status' ? 'active' : ''}`}
                            onClick={() => this.handleTabClick('financial-status')}
                        >
                            <em className="icon ni ni-cart"></em>
                            <span>وضعیت مالی</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'sale-and-receipts' ? 'active' : ''}`}
                            onClick={() => this.handleTabClick('sale-and-receipts')}
                        >
                            <em className="icon ni ni-list-round"></em>
                            <span>فروش و دریافت ها</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'purchases-and-payments' ? 'active' : ''}`}
                            onClick={() => this.handleTabClick('purchases-and-payments')}
                        >
                            <em className="icon ni ni-capsule"></em>
                            <span>خرید و پرداخت ها </span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'costs-and-revenue' ? 'active' : ''}`}
                            onClick={() => this.handleTabClick('costs-and-revenue')}
                        >
                            <em className="icon ni ni-notice"></em>
                            <span>هزینه و درآمد</span>
                        </a>
                    </li>
                </ul>


                {activeTab === 'financial-status' && <div >
                    <FinancialStatus />
                </div>}
                {activeTab === 'sale-and-receipts' && <div>
                    <SaleAndReceipts />
                </div>}
                {activeTab === 'purchases-and-payments' && <div>
                    <PurchasesAndPayments />
                </div>}
                {activeTab === 'costs-and-revenue' && <div>
                    <CostsAndRevenue />
                </div>}
            </div> 
    </div>

    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmptyAnnualsOrCompanies(this.state.data.global) ? this.renderNoCompanyOrAnnualRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}
